import React from 'react';
import styles from 'containers/Layouts/Layout.module.css';
import i18n from 'i18n/I18nInstance';
import _ from 'classnames';
import IconButton from '@mui/material/IconButton';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

interface IProps {
    transcript: string;
    isShowingTranscript: boolean;
    onTranscriptVisibilityChange: () => void;
}

export default function VideoTranscript(props: IProps) {
    const hiddenTranscript = () => {
        const i18n_showTranscript = i18n.translator.formatMessage({
            id: 'videoTranscript.ShowTranscription',
            defaultMessage: 'SHOW TRANSCRIPT',
        });

        return (
            <React.Fragment>
                <div
                    data-qaid="transcriptHidden"
                    className={_(
                        styles.imageWithText,
                        styles.noPrint,
                        styles.showTranscriptContainer,
                    )}
                >
                    <IconButton
                        onClick={props.onTranscriptVisibilityChange}
                        className={styles.showTranscriptIconWrapper}
                        focusRipple={false}
                        aria-label={i18n_showTranscript}
                    >
                        <div
                            data-qaid="transcriptShowText"
                            className={_(styles.textForImage, styles.imageWithText)}
                        >
                            {i18n_showTranscript}
                        </div>

                        <ExpandMore
                            className={styles.transcriptIcon}
                            data-qaid="transcriptShowIcon"
                        />
                    </IconButton>
                </div>
            </React.Fragment>
        );
    };

    const viewingTranscript = () => {
        const i18n_hideTranscript = i18n.translator.formatMessage({
            id: 'videoTranscript.HideTranscription',
            defaultMessage: 'HIDE TRANSCRIPT',
        });
        const transcriptHtml = { __html: props.transcript };
        return (
            <React.Fragment>
                <div className={styles.displayVideoText}>
                    <div
                        data-qaid="transcriptViewing"
                        className={_(
                            styles.noPrint,
                            styles.imageWithText,
                            styles.showTranscriptContainer,
                        )}
                    >
                        <IconButton
                            onClick={props.onTranscriptVisibilityChange}
                            className={styles.showTranscriptIconWrapper}
                            focusRipple={false}
                            aria-label={i18n_hideTranscript}
                        >
                            <div
                                data-qaid="transcriptHideText"
                                className={_(styles.textForImage, styles.imageWithText)}
                            >
                                {i18n_hideTranscript}
                            </div>

                            <ExpandLess
                                className={styles.transcriptIcon}
                                data-qaid="transcriptHideIcon"
                            />
                        </IconButton>
                    </div>
                    <div
                        data-qaid="transcript"
                        className={styles.educationText}
                        dangerouslySetInnerHTML={transcriptHtml}
                    />
                </div>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {props.isShowingTranscript ? viewingTranscript() : hiddenTranscript()}
        </React.Fragment>
    );
}
